// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"7e651eda","485":"636b7bda","501":"ea00e185"}[chunkId] + ".chunk.js";
};